export const OTPScreenTexts = {
    DesktopHeader: 'Код из СМС',
    ChangePhoneNumberLabel: 'Изменить номер',
    ContinueButtonLabel: 'Продолжить',
    RestartLabel: 'Начать снова',
    SentToPhoneText: 'Отправили его на номер',
};
